import { GLOBAL_CONFIG } from "@/global-config";

export const LoginExtraParams = {
	randomStr: "blockPuzzle",
	code: "",
	grant_type: "password",
	scope: "server",
};

const { oatuh2PasswordSecret, oauth2PasswordClient } = GLOBAL_CONFIG;
const credentials = `${oauth2PasswordClient}:${oatuh2PasswordSecret}`;
const base64Credentials = btoa(credentials);
export const LoginExtraHeaders = {
	skipToken: true,
	Authorization: `Basic ${base64Credentials}`,
	"Content-Type": "application/x-www-form-urlencoded",
	"TENANT-ID": 1,
};

// 微信 OAuth 配置
export const WechatAuthUri = "https://open.weixin.qq.com/connect/qrconnect";
export const WechatAuthState = encodeURIComponent("WECHAT_OPEN");
export const WechatAuthRedirectPath = "/auth";
